import { render, staticRenderFns } from "./LogManagementPage.vue?vue&type=template&id=0451cb10&scoped=true"
import script from "./LogManagementPage.vue?vue&type=script&lang=js"
export * from "./LogManagementPage.vue?vue&type=script&lang=js"
import style0 from "./LogManagementPage.vue?vue&type=style&index=0&id=0451cb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451cb10",
  null
  
)

export default component.exports